import { css } from '@emotion/core';
import { tokens, media, globalTokens, rgba, applyFont } from '@domain-group/fe-brary';
const colours = tokens.colors,
  typography = tokens.typography;
const lightSurface = globalTokens.colors.white;
const darkSurface = '#1E293D';
export const collapse = {
  name: "79elbk",
  styles: "position:relative;"
};
export const fade = /*#__PURE__*/css("background:linear-gradient( to bottom,", rgba(lightSurface, 0), " 0%,", rgba(lightSurface, 1), " 75% );position:absolute;bottom:0;width:100%;height:100px;");
export const darkFade = /*#__PURE__*/css("@media (prefers-color-scheme:dark),[data-theme='dark']{background:linear-gradient( to bottom,", rgba(darkSurface, 0), " 0%,", rgba(darkSurface, 1), " 75% );}");
export const toggleButton = /*#__PURE__*/css("display:block;width:100%;outline:none;padding:5px 0;border:0;background:none;cursor:pointer;color:", colours.neutral.heavy.default, ";", applyFont(typography.bodyBold));
export const toggleButtonClosed = /*#__PURE__*/css("border-bottom:1px solid ", colours.neutral.trim.default, ";text-transform:uppercase;", media('>=tablet'), "{border:0;text-transform:none;}");
export const toggleButtonLabel = {
  name: "1wjzfjl",
  styles: "display:inline-block;float:right;margin-right:5px;"
};
export const toggleButtonClosedLabel = /*#__PURE__*/css("float:left;color:", colours.neutral.heavy.default, ";");
export const toggleButtonIcon = {
  name: "146q31f",
  styles: "float:right;"
};
export const contentBlock = {
  name: "vtn2l4",
  styles: "padding-bottom:20px;"
};